import { Controller } from "@hotwired/stimulus";
import _ from "lodash";

export default class extends Controller {
  static targets = [
    "licensesList",
    "licenseRow",
    "destroyField",
    "removeButton",
    "noLicenseMsg",
    "licenseTemplate",
    "radiusLabel",
    "radiusInput"
  ];

  connect() {
    // Find the template HTML and compile it with lodash
    if (!this._licenseTemplateFn) {
      const templateHtml = this.licenseTemplateTarget.innerHTML;
      this._licenseTemplateFn = _.template(templateHtml, { interpolate: /{{([\s\S]+?)}}/g });
    }
  }

  addLicenseRow(event) {
    event.preventDefault();
    // Find the highest index currently used
    let maxIndex = -1;
    this.licenseRowTargets.forEach(row => {
      const input = row.querySelector("input,select,textarea");
      if (input && input.name) {
        const match = input.name.match(/\[licenses_attributes\]\[(\d+)\]/);
        if (match) {
          maxIndex = Math.max(maxIndex, parseInt(match[1], 10));
        }
      }
    });
    const newIndex = maxIndex + 1;

    // Render the template with the new index
    const html = this._licenseTemplateFn({ index: newIndex });
    // Convert HTML string to DOM node
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    const newRow = tempDiv.firstElementChild;

    // Append the new row
    this.licensesListTarget.appendChild(newRow);

    // Hide the "no licenses" message if present
    if (this.hasNoLicenseMsgTarget) {
      this.noLicenseMsgTarget.style.display = "none";
    }
  }

  removeLicenseRow(event) {
    event.preventDefault();
    const button = event.currentTarget;
    const row = button.closest(".license-fields-row");

    // Find the _destroy field within this row
    const destroyField = row.querySelector('[data-provider-profile-form-target="destroyField"]');

    // Check if this is a persisted record (has an ID)
    const idField = row.querySelector('input[name*="[id]"]');
    const isPersisted = idField && idField.value;

    if (isPersisted && destroyField) {
      // For persisted records, mark for deletion and hide
      destroyField.value = "true";
      row.style.display = "none";
    } else {
      // For new records, just remove from DOM
      row.remove();
    }

    // If all visible rows are removed, show the "no licenses" message
    setTimeout(() => {
      const visibleRows = this.licenseRowTargets.filter(row => row.style.display !== "none");
      if (visibleRows.length === 0 && this.hasNoLicenseMsgTarget) {
        this.noLicenseMsgTarget.style.display = "block";
      }
    }, 0);
  }

  updateRadiusLabel() {
    const value = this.radiusInputTarget.value;
    // Find the span inside the label and update its text
    const span = this.radiusLabelTarget.querySelector("#travel-radius-value");
    if (span) {
      span.textContent = value;
    }
  }
}
